<template>
  <tr>
    <td>
      {{ product.vendor_name }}
      <div v-if="current"><Badge :text="translations.currently_chosen" /></div>
    </td>
    <td class="text-nowrap">{{ product.price }}</td>
    <td class="text-nowrap">
      {{ product.shipping }}
      <br />
      <small v-if="product.package_delivery_hint">
        {{ translations.package_delivery_hint }}
      </small>
    </td>
    <td class="text-right text-nowrap">
      <button v-if="current" class="btn btn-disabled btn-sm" disabled>
        {{ translations.visit }}
      </button>
      <a v-else :href="product.path" class="btn btn-primary btn-sm">{{ translations.visit }}</a>
    </td>
  </tr>
</template>

<script>
import Badge from "./Badge";

export default {
  name: "OtherVendorsModalVendorRow",
  components: { Badge },
  props: {
    current: {
      type: Boolean,
      default: false,
    },
    product: {
      type: Object,
      required: true,
    },
    translations: {
      type: Object,
      required: true,
    },
  },
};
</script>
